import React from "react";
import { Box, Grid, Paper, Typography, Button, Divider } from "@material-ui/core";
import AppleIcon from "@material-ui/icons/Apple";
import AndroidIcon from "@material-ui/icons/Android";
import {
  PARENT_APP_PLAY_STORE_URL,
  PARENT_APP_APP_STORE_URL,
  TEACHER_APP_PLAY_STORE_URL,
  TEACHER_APP_APP_STORE_URL,
} from "../../constants/mobileApps";

function StoreLink({ href, icon, label, bg }) {
  return (
    <Button
      variant="contained"
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      startIcon={icon}
      style={{
        backgroundColor: bg,
        color: "#fff",
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 8,
        marginRight: 8,
        marginBottom: 8,
      }}
    >
      {label}
    </Button>
  );
}

function AppCard({ title, description, androidUrl, iosUrl }) {
  return (
    <Paper
      elevation={0}
      style={{
        padding: 20,
        borderRadius: 12,
        border: "1px solid #e2e8f0",
        height: "100%",
      }}
    >
      <Typography style={{ fontWeight: 700, color: "#0f3b62", marginBottom: 4 }}>
        {title}
      </Typography>
      <Typography style={{ fontSize: "0.85rem", color: "#64748b", marginBottom: 14 }}>
        {description}
      </Typography>
      <StoreLink href={androidUrl} icon={<AndroidIcon />} label="Android" bg="#1a9b54" />
      <StoreLink href={iosUrl} icon={<AppleIcon />} label="iOS" bg="#111827" />
    </Paper>
  );
}

export default function MobileAppLinksSection({ style }) {
  return (
    <Box style={style}>
      <Typography style={{ fontWeight: 700, color: "#0f2d4d", marginBottom: 12, fontSize: "1rem" }}>
        Mobile Apps
      </Typography>
      <Typography style={{ fontSize: "0.85rem", color: "#64748b", marginBottom: 16 }}>
        Share these links with parents and teachers to install the MonteStory app on Android or iOS.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <AppCard
            title="Parent App"
            description="Assignments, fees, activity progress, calendar, and student profile."
            androidUrl={PARENT_APP_PLAY_STORE_URL}
            iosUrl={PARENT_APP_APP_STORE_URL}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <AppCard
            title="Teacher App"
            description="Activities, attendance, student progress, and school updates."
            androidUrl={TEACHER_APP_PLAY_STORE_URL}
            iosUrl={TEACHER_APP_APP_STORE_URL}
          />
        </Grid>
      </Grid>
      <Divider style={{ marginTop: 8 }} />
    </Box>
  );
}
